import './modalWrapper.scss';

import Copy from '../../../assets/images/icons/tabler--copy.png';

import { useAppDispatch } from '../../../features';
import { generateNposLink, getNposList } from '../../../store/UserSlice';
import { GeneratedLink } from '../../../types/user';
import { Button } from '../button/button';

import React, { FunctionComponent, useState } from 'react';
import { localFormatter } from '../../../utils/textFormatter';
import { setNotificationButtonLoad } from '../../../store/NotificationSlice';
import { QRCodeCanvas } from 'qrcode.react';
import { setModalSignInUp } from '../../../store/AppSlice';
import { modalTypeEnum } from '../../../types/modal';
import { fetchNposList } from '../../../store/NposSlice';

type PropsStepper = {
    onClick: () => void,
    data?: GeneratedLink,
    onNameChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onFeeChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const ModalNpos: FunctionComponent = () => {

    const dispatch = useAppDispatch();

    const [step, setStep] = useState(0);
    const [name, setName] = useState('');
    const [fee, setFee] = useState('');
    const [data, setData] = useState<GeneratedLink>();

    let Component = ModalNposFirst;
    if(step === 1) Component = ModalNposSecond;

    const handleClick = async () => {
        dispatch(setNotificationButtonLoad(true))
        const resp = await dispatch(generateNposLink(name, fee));
        if (resp) {
            dispatch(setNotificationButtonLoad(false))
            setStep(1);
            setData(resp);
        }
    }

    const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setName(e.target.value);
    };

    const handleFeeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        
        let input = e.target.value;
        e.target.value = input.replace(/[^0-9]/g, '');
        setFee(e.target.value);
    };


    return (
        <Component 
            onClick={handleClick} 
            data={data} 
            onNameChange={handleNameChange} 
            onFeeChange={handleFeeChange} 
        />
    )
}

const ModalNposFirst : FunctionComponent<PropsStepper> = (props) => {

    const dispatch = useAppDispatch();

    const [isOverMaximum, setisOverMaximum] =  useState<boolean>(false);

    const closeModal = () => {
        dispatch(fetchNposList());
        dispatch(setModalSignInUp(modalTypeEnum.none));
    }

    const handleChange = (e:any) => {

        if (!e || e.target.value > 50) {
            setisOverMaximum(true);
        } else {
            setisOverMaximum(false);
            if (e) props.onFeeChange(e);
        }

    }

    const handleClick = () => {
        if (!isOverMaximum) props.onClick();
    }

    // REGEX
    const [value, setValue] = useState("");
    const [isValid, setIsValid] = useState<boolean|null>(null);

    const regex = /^(?=(?:.*[A-Za-z]){4,})[A-Za-z0-9]{6,16}$/;

    const handleChangeNposNickName = (e:any) => {
        const input = e.target.value;
        setValue(input);
        setIsValid(regex.test(input));
        props.onNameChange(e);
    };    

    return (
        <>
            <div className="modal modal-npos first">
                <h1>
                    Adição de NPOS
                    <small>(Next generation point of sale)</small>
                </h1>

                <p>
                    Ao continuar com o processo, você estará adicionando mais um ponto de venda para seu empreendimento.<br/>
                    Esse ponto não poderá alterar a carteira de destino e sé terá funcionalidades restritas:
                </p>

                <div className='new-npos-info'>
                    <h2>Novo NPoS:</h2>
                    <h3>Apelido: <span>(para  seu controle)*</span></h3>
                    <div className="form-control">
                        <input type="text" placeholder='Nome/Apelido do Npos' 
                            className={isValid === null
                                ? "border-gray"
                                : isValid
                                ? "border-green"
                                : "border-red"
                            }
                            value = {value}
                            onChange={handleChangeNposNickName} />
                            {isValid === false && (
                                <p className="text-danger">
                                    Entrada inválida: 6–16 caracteres, mínimo 4 letras, sem espaços ou especiais.
                                </p>
                            )}
                            {isValid === true && (
                                <p className="text-success">
                                    Apelido correto
                                </p>
                            )}
                        <small>Não obrigatório</small>
                    </div>
                    <h3>Taxa: <span>(se você deseja adicionar uma taxa adicional para esse npos)*</span></h3>
                    <div className="form-control">
                        <input type="text" placeholder='Exemplo: 20 centavos' onChange={handleChange}/>
                        <small className={ isOverMaximum ? `text-danger` : `` }>Não obrigatório - máximo 50 centavos</small>
                    </div>
                </div>


                <ul>
                    <li>Gerar pagamentos</li>
                    <li>Ver apenas transações desse ponto</li>
                    <li>Não poderá gerar links de acesso</li>
                    <li>Não alterará nenhuma informação de perfil</li>
                </ul>

                <div className="navigation">
                    <Button label='Cancelar' onClick={closeModal}/>
                    <Button label='Gerar' onClick={handleClick} { ...(isOverMaximum ? { disabled: true } : {})} />
                </div>

            </div>
        </>
    )
}

const ModalNposSecond : FunctionComponent<PropsStepper> = (props) => {
    
    const dispatch = useAppDispatch()

    const [isCopyInProgress, setIsCopyInProgress] = useState<boolean>(false); 

    const handleCopy = () => {
        if(props.data) {
            navigator.clipboard.writeText(localFormatter(props.data.data.link)).then(function() {
                setIsCopyInProgress(true);
                const timer = setTimeout( () => {
                    setIsCopyInProgress(false);
                    clearTimeout(timer)
                }, 3000);
            }, function(err) {
                console.error('Async: Could not copy text: ', err);
            });
        }
    }

    const handleButtonClick = () => {
        dispatch(fetchNposList())
        dispatch(setModalSignInUp(modalTypeEnum.none))
    }

    return (


        <div className="modal modal-npos first">
            <h1>
                Link gerado:
                <img alt="" src="https://chart.googleapis.com/chart?cht=qr&chl=teste&chs=180x180&choe=UTF-8&chld=L|2"></img>
                <small>Use o Qrcode Abaixo ou compartilhe o link</small>
            </h1>

            <div className='share-link' onClick={handleCopy}>
                { isCopyInProgress && (
                    <>
                        <p className='text'> Codigo copiado com sucesso! </p>
                    </>
                )}
                { !isCopyInProgress && (
                    <>
                        <p className="text">
                            {props.data?.data?.link}
                        </p>
                        <img src={Copy} alt=""/>
                    </>
                )}
            </div>
            <div className="qrcode">
                
                <QRCodeCanvas 
                    value={props.data?.data?.link || ''}
                    size={300}
                    title={'uhu'} />
            </div>
            <div className="alert alert-warning">
                *Não compartilhar esse qrcode ou link com pessoas desconhecidas!
            </div>

            <Button label="Fechar" onClick={ handleButtonClick}
            ></Button>
        </div>
    )
}
